export const RPC_ENDPOINT = process.env.RPC_TYPE == "mainnet" ? "https://bsc-dataseed.binance.org/" : "https://data-seed-prebsc-1-s1.binance.org:8545/";

export const RPC_TIMEOUT_MS = 90000; // 30 Seconds

export const PAGE_SIZE_CONSTANT = 20;

// Tables
export const EVENTS_TABLE_NAME                  = "martian_events";
export const TICKETS_TABLE_NAME                 = "ticket_address";
export const LOCKED_TICKETS_TABLE_NAME          = "locked_tickets";
export const TICKET_ORDER_TABLE_NAME            = "ticket_order";
export const TICKET_ORDER_ITEM_TABLE_NAME       = "ticket_order_item";
export const EVENT_TICKET_OPTION_TABLE_NAME     = "event_ticket_option";
export const USERS_TABLE_NAME                   = "public_profiles";
export const PROFILES_TABLE_NAME                = "profiles";
export const CUSTODIAL_HOLDING_TABLE_NAME       = "custodial_holding_instance";
export const CUSTODIAL_WALLETS_TABLE_NAME       = "custodial_wallets";
export const GENERATED_TICKET_VERIFICATIONS_TABLE_NAME = "generated_ticket_verifications";

export const EVENT_TABLE_QUERY = "event_id, event_name, event_description, start_date, end_date, total_hours_live, predicted_attendance, actual_attendance, tags, contract_address, onchain_solution, ticket_collection_image_url, host_martian_name, hosted_by, venue_id";
export const EVENT_TABLE_QUERY2 = "event_id, event_name, event_description, start_date, end_date, total_hours_live, predicted_attendance, actual_attendance, tags, contract_address, onchain_solution, ticket_collection_image_url, host_martian_name, hosted_by, venue_id, country,postcode,address_line_1,address_line_2,address_line_3";
export const TICKET_TABLE_QUERY = "id, contract_address, owner_address, ticket_generation_available, fiat_cost, fiat_currency, number_of_reserved_tickets_for_fiat_payments, number_of_tickets_for_direct_minting, ticket_name";
export const LOCKED_TICKETS_TABLE_QUERY = "id, locked_by_user_id, locked_ticket_amount, checkout_fulfilled, expired, created_at_unix, unlock_timestamp_unix, ticket_id";
export const TICKET_ORDER_TABLE_QUERY = "id, user_id, payment_status, stripe_session_id, amount_subtotal, amount_total, currency";
export const TICKET_ORDER_ITEM_TABLE_QUERY = "id, ticket_order_id, ticket_id, purchase_quantity, locked_ticket_id";
export const EVENT_TICKET_OPTION_QUERY = "id, event_id, ticket_id, order";
export const CUSTODIAL_HOLDING_QUERY = "id, ticket_address, token_id, ownership_valid, owner_address, is_locked, user_id";

export const TICKET_USAGE_TABLE_NAME = "ticket_usage";

export const TICKET_MINT_QUEUE = "mint_queue";
export const LOCK_TICKET_QUEUE = "lock_queue";
export const TICKET_GENERATION_QUEUE = 'ticket_generation_queue';

export const NAITRAM_META_DESCRIPTION = "Naitram - Blockchain Ticketing"

export const ADDRESS_DEFAULT = "0x9D2F47e080D3621828AF8a3ee546430Cfd230cff";